module.exports = __webpack_public_path__ + "img/hero.52c91eea.png";